export default {
  namespaced: true,
  state: {
    opened: false,
    title: null,
    subtitle: null,

    consultationResponseMode: false,
  },
  getters: {
    isOpened(state) {
      return state.opened;
    },
  },
  actions: {
    SET_CHAT({ commit }, options = {}) {
      commit('SET_CHAT', options);
    },
  },
  mutations: {
    SET_CHAT: (state, options) => {
      Object.assign(state, options);
    },
  },
};
